import axios from "axios";

var baseURL;
if (typeof webpackHotUpdate  === 'function') {
  baseURL = "http://localhost:3031/"
} else {
  baseURL = "/api/"
}
const API = axios.create({
  baseURL: baseURL
});

const minute = 60;
const hour = minute * 60;
const day = hour * 24;

const cachedPaths = [
  { path: "ingredients",                    expires: day            },
  { path: "beer-sub-styles",                expires: day            },
  { path: "yeasts",                         expires: day            },
  { path: "hops",                           expires: day            },
  { path: "hop-forms",                      expires: day            },
  { path: "recipe-types",                   expires: day            },
  { path: "^recipes\/\\d+\/brew-sessions",  expires: minute * 30, bypass: ['logged-in'] },
  { path: "^recipes\/\\d+\/",               expires: minute * 30, bypass: ['logged-in'] },
  { path: "^recipes",                       expires: minute * 10, bypass: ['logged-in'] },
  { path: "^brew-sessions\/\\d+\/stream",   expires: minute * 30, bypass: ['logged-in'] },
  { path: "^brew-sessions\/\\d+",           expires: minute * 30, bypass: ['logged-in'] },
  { path: "^brew-sessions",                 expires: minute * 30, bypass: ['logged-in'] },
  { path: "^streams",                       expires: minute * 30, bypass: ['logged-in'] },
  { path: "other-ingredients",              expires: day            },
  { path: "other-ingredient-uses",          expires: day            },
  { path: "hop-uses",                       expires: day            }
];

API.interceptors.response.use(response => {
  if (response.data && response.config.method === "get") {
    let key = response.config.url.replace(response.config.baseURL, "");
    let cachedPath = _(cachedPaths).find((item) => {
      let regex = new RegExp(item.path);
      return regex.test(key);
    });

    if (cachedPath) {
      let currentTime = Math.round(Date.now() / 1000);
      let expirationTime = currentTime + cachedPath.expires;
      let storeKey = "request_" + key;
      localStorage[storeKey] = JSON.stringify(response.data);
      localStorage[storeKey + "_expires"] = expirationTime;
    }
  }
  return response;
});

API.interceptors.request.use(
  config => {
    if (localStorage.getItem("token")) {
      config.headers.Authorization = localStorage.getItem("token");
    }
    return config;
  },
  error => Promise.reject(error)
);

export const HTTP = {
  get: function(url) {
    let key = url.replace(API.defaults.baseURL, '');
    let storeKey = "request_" + key;
    let cachedPath = _(cachedPaths).find((item) => {
      let regex = new RegExp(item.path);
      return regex.test(key);
    });

    if (cachedPath && cachedPath.bypass && _(cachedPath.bypass).includes('logged-in') && localStorage.token) {
      console.info('Bypassing local cache for', cachedPath.path);
      cachedPath = null;
    }

    if (cachedPath && localStorage[storeKey] && Math.round(Date.now() / 1000) < parseInt(localStorage[storeKey + "_expires"])) {
      return new Promise(function(resolve, reject) {
        resolve({ data: JSON.parse(localStorage["request_" + key]) });
      });
    } else {
      delete localStorage[storeKey];
      delete localStorage[storeKey + "_expires"];
      return API.get(url);
    }
  },
  post: function(url, data, config) {
    return API.post(url, data, config);
  },
  patch: function(url, data) {
    return API.patch(url, data);
  },
  delete: function(url, data) {
    return API.delete(url, data);
  }
};
